var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownlaod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1211 12.6899V1.00781",
    stroke: "white",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0371 9.84766L11.1211 12.6884L8.20511 9.84766",
    stroke: "white",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7541 5.60156H16.6871C17.171 5.60156 17.6501 5.69404 18.0971 5.87372C18.5442 6.05341 18.9503 6.31677 19.2924 6.64876C19.6345 6.98076 19.9059 7.37489 20.091 7.80864C20.276 8.2424 20.3712 8.70728 20.3711 9.17673V13.9152C20.3711 14.8608 19.9839 15.7677 19.2947 16.4363C18.6055 17.105 17.6708 17.4806 16.6961 17.4806H5.55609C4.57877 17.4806 3.64148 17.1039 2.95041 16.4335C2.25933 15.763 1.87109 14.8536 1.87109 13.9055V9.16605C1.87136 8.2206 2.25866 7.31396 2.94783 6.64552C3.637 5.97708 4.5716 5.60156 5.54609 5.60156H6.48809",
    stroke: "white",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownlaod);
export default __webpack_public_path__ + "static/media/Downlaod.32f2c5e487da7bf11ba0753880a005fb.svg";
export { ForwardRef as ReactComponent };